import React from 'react';

// Shared bits for the document-review pages.

export const CLASS_TONE = {
  GREEN: { bg: 'var(--surface-green)', fg: 'var(--text-green)', dot: 'var(--color-green-500)', label: 'Low risk' },
  YELLOW: { bg: 'var(--surface-yellow)', fg: 'var(--text-yellow)', dot: 'var(--color-yellow-500)', label: 'Some risk' },
  RED: { bg: 'var(--surface-red)', fg: 'var(--text-critical)', dot: 'var(--color-red-500)', label: 'High risk' },
};

const STATUS_TONE = {
  pending_review: { cls: 'yellow', label: 'Awaiting legal' },
  changes_requested: { cls: 'yellow', label: 'Changes requested' },
  approved: { cls: 'green', label: 'Approved' },
  rejected: { cls: 'red', label: 'Rejected' },
  withdrawn: { cls: 'gray', label: 'Withdrawn' },
};

export function ReviewStatusChip({ status }) {
  const t = STATUS_TONE[status] || { cls: 'gray', label: status || 'Unknown' };
  return <span className={`chip ${t.cls}`}><span className="dot" />{t.label}</span>;
}

// The AI triage classification, or its in-flight/failed state.
export function TriageChip({ aiStatus, classification }) {
  if (aiStatus === 'queued' || aiStatus === 'running') {
    return <span className="chip gray"><span className="dot" />AI triage running…</span>;
  }
  if (aiStatus === 'failed') return <span className="chip gray">AI triage unavailable</span>;
  if (aiStatus !== 'complete' || !classification) return <span className="muted" style={{ fontSize: 12 }}>—</span>;
  const tone = CLASS_TONE[classification] || CLASS_TONE.YELLOW;
  return (
    <span className="chip" style={{ background: tone.bg, color: tone.fg, fontWeight: 600 }}>
      <span className="dot" style={{ background: tone.dot }} />
      {classification}
    </span>
  );
}
